import { createSelector } from 'reselect';
import {
  selectBrand as selectUserRegionBrand,
  selectBranch as selectUserRegionBranch,
} from 'containers/UserRegion/selectors';
import { getBrandIdByLegacyId } from './index';

/**
 * Select the acq brand from the UserRegion state.
 * Self-service (location) fallback removed since this app is acquisition-only.
 */
export const selectBrand = () =>
  createSelector(selectUserRegionBrand(), (acqRes) => {
    return acqRes ? getBrandIdByLegacyId(acqRes) : null;
  });

/**
 * Select the acq branch from the UserRegion state.
 * Self-service (location) fallback removed since this app is acquisition-only.
 */
export const selectBranch = () =>
  createSelector(selectUserRegionBranch(), (acqBranch) => acqBranch || null);
